import React from 'react'

export default function About() {
    return (
        <div className='container my-5'>
            <div className='row'>
                <div className='col-lg-2 col-md-0'></div>
                <div className='col-lg-8 col-md-12'>
                    <div className="card">
                        <img src="https://qph.fs.quoracdn.net/main-qimg-c74778d67b3c3d3419cf86b755b32b06" className="card-img-top" alt="React Banner" />
                        <div className="card-body">
                            <p className="card-text">Well come on, how could you call yourself a react developer without creating a todo app &#x1F606;</p>
                        </div>
                    </div>
                </div>
                <div className='col-lg-2 col-md-0'></div>
            </div>
        </div>
    )
}
